import {useEffect, useState} from 'react'
import {useRouter} from 'next/router'
import type {Elements, IContentItem} from '@kontent-ai/delivery-sdk'
import type {Block} from '@/services/kontent-ai/types'

export type BazaarVoiceReviewsContentItem = IContentItem<{
	productId: Elements.TextElement
}>

export const BazaarVoiceReviewsBlock: Block<BazaarVoiceReviewsContentItem> = ({
	block,
}) => {
	const router = useRouter()
	const [productId, setProductId] = useState(block.elements.productId)

	useEffect(() => {
		const sku =
			typeof router.query.sku === 'string' ? router.query.sku : undefined
		setProductId(sku || block.elements.productId)
	}, [router.query.sku, block.elements.productId])

	return (
		<div
			data-bv-product-id={productId}
			data-bv-show="reviews"
			data-kontent-element-codename="product_id"
		/>
	)
}
